import * as Roles from "@/constants/roles";

export default {
    computed: {
        assigneeOptions() {
            let users = _.filter(this.$store.state.users.data, (user) => {
                if (user.is_assignable) {
                    return !!_.find(user.roles.data, (role) =>
                        _.includes(Roles.MAIN_ROLES, role.role)
                    );
                }
            });
            users = _.concat(users, this.$store.state.user);
            return _.sortBy(users, "name");
        },
    },
};
